import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type activationOrderCreationDataType = {
  id: string;
  errorCallback: Function;
  resultKey?: string;
};

export default ({ id, errorCallback, resultKey = 'activationOrderCreationData' }: activationOrderCreationDataType) =>
  requestAsync({
    url: endpoints.getActivationOrderCreationUrl(id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getActivationOrderCreationUrl(id),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
